<template>
  <div class="text-options-data-dialog">
    <div
      :class="detailFieldMappingFieldFlag && detailFiledMappingChecked ? 'mapping_content checked' : 'mapping_content'"
    >
      <div class="verticallyBetweenCenter">
        <div class="content-title">
          {{ getValueByTypeHandle(options.innerElement) }}
        </div>
        <div class="verticallyCenter" v-if="options.innerElement == 'cxText' || options.innerElement == 'cxLabel'">
          <el-checkbox v-model="textHyperlink" v-if="options.innerElement == 'cxText'">超链接</el-checkbox>
          <el-checkbox v-model="isHyperlink" v-else>超链接</el-checkbox>
        </div>
      </div>
      <div class="select_content mt8">
        <el-select style="width: 100%" v-model="detailFieldMappingFieldFlag" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in detailFieldMappingList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mapping_date_content mt8" v-if="!isDateFlag && !['imageComponent'].includes(options.innerElement)">
        <label class="date-label">显示为:</label>
        <el-dropdown trigger="click" @command="onChangeMappingType">
          <span class="el-dropdown-link">
            {{ fieldMappingDataType }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="custom-dropdown">
            <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
              <div :class="detailFieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                {{ item.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="verticallyCenter mapping_date_content mt8" v-else-if="!['imageComponent'].includes(options.innerElement)">
        <label class="date-label">显示为:</label>
        <el-dropdown trigger="click" @command="onChangeMappingDateStyle">
          <span class="el-dropdown-link">
            {{ fieldMappingDateStyle }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="custom-dropdown">
            <div class="dropdown-title-show">
              <cx-check-box :value.sync="detailFieldMappingDateTitle" @change="onChangeMappingDateTitle"
                >显示字段名</cx-check-box
              >
            </div>
            <el-dropdown-item v-for="item in dateOptions" :key="item.value" :command="item.value">
              <div :class="detailFieldMappingDateStyle === item.value ? 'dropdown-item active' : 'dropdown-item'">
                {{ item.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="select_content mt8" v-if="options.isHyperlink">
        <el-select style="width: 100%" v-model="detailFieldMappingLinkField" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in detailFieldMappingList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mt4" v-if="options.isHyperlink">
        <el-checkbox v-model="options.openBlankPage">新页面打开</el-checkbox>
      </div>
      <div v-if="options.innerElement == 'cxVideo' || options.innerElement == 'cxAudio'" class="vedio-style mt8">
        <el-checkbox v-model="videoObjectId"></el-checkbox><label>支持云盘</label>
      </div>
    </div>
  </div>
</template>

<script>
import { getValueByType } from "utils"
import { historyIgnoreWrap } from "utils/revork"
export default {
  name: "detailPageFieldMappingSetting",
  components: {},
  props: {
    myid: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      dataTypeList: [
        {
          label: "字段名称：字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ],
      detailFieldMappingList: [], // 详情页数据源
      dateOptions: [
        {
          value: "7",
          label: "年-月-日 时:分:秒"
        },
        {
          value: "10",
          label: "年-月-日 时:分"
        },
        {
          value: "1",
          label: "年-月-日"
        },
        {
          value: "2",
          label: "年-月"
        },
        {
          value: "3",
          label: "月-日"
        },
        {
          value: "8",
          label: "时:分"
        },
        {
          value: "4",
          label: "年"
        },
        {
          value: "5",
          label: "月"
        },
        {
          value: "6",
          label: "日"
        },
        {
          value: "9",
          label: "文本格式"
        }
      ],
      detailFiledMappingValue: {},
      isDateFlag: false
    }
  },
  computed: {
    detailFieldMapping() {
      if (!this.options.detailFieldMapping) {
        this.$changeOptionsEV({}, "detailFieldMapping", false, null, {
          ...this.myid
        })
      }
      return this.options.detailFieldMapping
    },
    detailFiledMappingChecked: {
      get() {
        return this.detailFieldMapping.isChecked
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "detailFieldMapping.isChecked", false, null, {
          ...this.myid
        })
      }
    },
    detailFieldMappingDataType: {
      get() {
        return this.detailFieldMapping.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "detailFieldMapping.dataType", false, null, {
          ...this.myid
        })
      }
    },
    detailFieldMappingLinkField: {
      get() {
        return this.detailFieldMapping.linkField
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "detailFieldMapping.linkField", false, null, {
          ...this.myid
        })
        const curObj = this.detailFieldMappingList.find(item => item.value === newVal)
        this.$changeOptionsEV(curObj.srcFlag || "", "detailFieldMapping.linkSrcField", false, null, {
          ...this.myid
        })
      }
    },
    detailFieldMappingFieldFlag: {
      get() {
        this.isDateFlagFunc(this.detailFieldMappingList, this.detailFieldMapping.fieldFlag)
        return this.detailFieldMapping.fieldFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "detailFieldMapping.fieldFlag", false, null, {
          ...this.myid
        })
        this.$changeOptionsEV(!!newVal, "detailFieldMapping.isChecked", false, null, {
          ...this.myid
        })
        const curObj = this.detailFieldMappingList.find(item => item.value === newVal)
        this.$changeOptionsEV(curObj.srcFlag || "", "detailFieldMapping.fieldSrcFlag", false, null, {
          ...this.myid
        })
        this.isDateFlagFunc(this.detailFieldMappingList, newVal)
      }
    },
    detailFieldMappingDateStyle: {
      get() {
        return this.detailFieldMapping.dateStyle || "9"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "detailFieldMapping.dateStyle", false, null, {
          ...this.myid
        })
        this.$changeOptionsEV(true, "detailFieldMapping.isDate", false, null, {
          ...this.myid
        })
      }
    },
    detailFieldMappingDateTitle: {
      get() {
        return this.detailFieldMapping.dataType === "dataKey"
      },
      set(newVal) {
        if (newVal) {
          this.$changeOptionsEV("dataKey", "detailFieldMapping.dataType", false, null, this.myid)
        } else {
          this.$changeOptionsEV("dataValue", "detailFieldMapping.dataType", false, null, this.myid)
        }
      }
    },
    textHyperlink: {
      get() {
        return this.options.textHyperlink
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textHyperlink", false, null, {
          ...this.myid
        })
      }
    },
    isHyperlink: {
      get() {
        return this.options.isHyperlink
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isHyperlink", false, null, {
          ...this.myid
        })
      }
    },
    videoObjectId: {
      get() {
        return this.options.videoObjectId
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videoObjectId", false, null, {
          ...this.myid
        })
      }
    },
    fieldMappingDataType() {
      const item = this.dataTypeList.find(data => data.value === this.detailFieldMappingDataType)
      return item && item.label || ""
    },
    fieldMappingDateStyle() {
      const item = this.dateOptions.find(data => data.value === this.detailFieldMappingDateStyle)
      return item && item.label || ""
    }
  },
  watch: {
    videoObjectId: {
      immediate: true,
      handler: function (n, o) {
        if (n) {
          this.dataTypeList.push({
            label: "objectId",
            value: "dataObjectId"
          })
        } else {
          this.dataTypeList.splice(3, 1)
        }
      }
    }
  },
  methods: {
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    isDateFlagFunc(list, flag) {
      historyIgnoreWrap(() => {
        for (let i = 0; i < list.length; i++) {
          if (list[i].value == flag) {
            if (list[i].isDate) {
              this.isDateFlag = true
              this.$changeOptionsEV(true, "detailFieldMapping.isDate", false, null, this.myid)
              this.$changeOptionsEV(this.detailFieldMappingDateStyle, "detailFieldMapping.dateStyle", false, null, this.myid)
            } else {
              this.isDateFlag = false
              this.$changeOptionsEV(false, "detailFieldMapping.isDate", false, null, this.myid)
            }
            break
          }
        }
      })()
    },
    onChangeMappingType(value) {
      this.detailFieldMappingDataType = value
    },
    onChangeMappingDateStyle(value) {
      this.detailFieldMappingDateStyle = value
    },
    onChangeMappingDateTitle(value) {
      this.detailFieldMappingDateTitle = value
    }
  },
  created() {
    if (window.localStorage.getItem("detailData")) {
      const detailData = JSON.parse(window.localStorage.getItem("detailData"))[0]
      Object.keys(detailData).forEach((key, index) => {
        if (key === "content" || key === "id" || key === "formId" || key === "videoCoverUrl" || key ==="videoObjectId") return
        if(detailData[key]?.key){
          const temp = {
            value: key,
            label: detailData[key].key,
            srcFlag: detailData[key].srcFlag || "",
            isDate: detailData[key].component_shape?.includes("cxDate") ? true : false
          }
          this.detailFieldMappingList.push(temp)
        }
      })
      // 视频详情返回的字段格式有差异
      if(this.options.innerElement === 'cxVideo'  && detailData.videoObjectId){
        this.detailFieldMappingList.push({
          value: "videoObjectId",
          label: "视频详情",
          srcFlag: ""
        })
      }
      // 检查字段是否匹配，优先按照srcFlag绑定
      if (this.detailFieldMapping.fieldSrcFlag) {
        const curObj = this.detailFieldMappingList.find(item => item.srcFlag === this.detailFieldMapping.fieldSrcFlag)
        if (curObj && curObj.value !== this.detailFieldMapping.fieldFlag) {
          this.$changeOptionsEV(curObj.value, "detailFieldMapping.fieldFlag", false, null, {
            ...this.myid
          }, true)
        }
      }
      if (this.detailFieldMapping.linkSrcField) {
        const curObj = this.detailFieldMappingList.find(item => item.srcFlag === this.detailFieldMapping.linkSrcField)
        if (curObj && curObj.value !== this.detailFieldMapping.linkField) {
          this.$changeOptionsEV(curObj.value, "detailFieldMapping.linkField", false, null, {
            ...this.myid
          }, true)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
  .verticallyBetweenCenter {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.text_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px;
  color: var(--elCollapseItemContentColor);
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
  .el-checkbox {
    margin-right: 4px;
  }
  ::v-deep .el-input .el-input__inner {
    background-color: var(--leftMenuBgColor);
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
</style>
